import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

const STORAGE_KEY = 'tracker-expanded-project-archive';

function loadFromStorage(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    return raw === '1' || raw === 'true';
  } catch {
    return false;
  }
}

function saveToStorage(expanded: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, expanded ? '1' : '0');
  } catch {
    // ignore
  }
}

/** Раскрытие спойлера «Архив» внизу таблицы проектов */
export function useExpandedArchive(): {
  expandedArchive: boolean;
  setExpandedArchive: Dispatch<SetStateAction<boolean>>;
} {
  const [expandedArchive, setExpandedArchive] = useState<boolean>(loadFromStorage);

  useEffect(() => {
    saveToStorage(expandedArchive);
  }, [expandedArchive]);

  return { expandedArchive, setExpandedArchive };
}
